import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-payment',
  templateUrl: './modal-view-branch-office.component.html',
  styleUrls: ['./modal-view-branch-office.component.scss']
})
export class ModalViewBranchOffice implements OnInit {

  coords: string;
  mapTouched: boolean = false;
  zones: any = [];
  cities: any = [];
  organizations : any = [];
  duePayments: any = [];
  branchs_types: any = this.uService.type_branchs;
  status: any = this.uService.status;
  newOrganizationForm: FormGroup = new FormGroup({
    city: new FormControl('', Validators.required),
    zone_id: new FormControl('', Validators.required),
    address: new FormControl('', Validators.required),
    house_number: new FormControl('', Validators.required),
    name_branch_office: new FormControl('', Validators.required),
    // type_br: new FormControl('', Validators.required),
    // status: new FormControl('', Validators.required),
    cost_center_name: new FormControl('', Validators.required),
    cost_center_code: new FormControl('', Validators.required),
  });

  getOrganizations(){
    this.mService.get_request('organizations/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        this.organizations = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getDuePayments(id: string){
    this.mService.get_request('due-payment/list', { organization_id: id })
    .subscribe((resp: any)=>{
      if(resp.status){
        this.duePayments = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getZones(){
    var fields: any = {
      city_id: this.newOrganizationForm.get('city').value
    }

    this.mService.get_request('zones/list', fields)
    .subscribe((resp: any)=>{
      if (resp.status) {
        this.zones = resp.items;
        if(this.uService.newShop.city != undefined){
          this.newOrganizationForm.get('zone_id').setValue(this.uService.newShop.zone_id);
        }
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  getCities(){
    this.mService.get_request('cities/list')
    .subscribe((resp: any)=>{
      if (resp.status) {
        this.cities = resp.items;
        this.getZones();
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  setCoords(coords: any){
    this.coords = coords;
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewBranchOffice>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.getCities();
    if(this.data.id != undefined){
      this.newOrganizationForm.get('city').setValue(this.data.city_id);
      this.newOrganizationForm.get('zone_id').setValue(this.data.zone_id);
      this.newOrganizationForm.get('address').setValue(this.data.address);
      this.newOrganizationForm.get('house_number').setValue(this.data.house_number);
      this.newOrganizationForm.get('name_branch_office').setValue(this.data.name_branch_office);
      // this.newOrganizationForm.get('type_br').setValue(this.data.type_br);
      // this.newOrganizationForm.get('status').setValue(this.data.status);
      this.newOrganizationForm.get('cost_center_name').setValue(this.data.cost_center_name);
      this.newOrganizationForm.get('cost_center_code').setValue(this.data.cost_center_code);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

